module.exports = __webpack_public_path__ + "img/lxby_vip.4c81fcf9.png";